import { isMarketingPath } from "~/utils/isDashboardPage";

const PORTAL_FONTS_ID = "portal-google-fonts";

/** Portal-only families (DM Sans/Mono, Caveat, Sora). Marketing uses self-hosted Geist / JetBrains / Instrument Serif. */
const PORTAL_FONT_HREF =
  "https://fonts.googleapis.com/css2?family=Caveat:wght@500&family=DM+Mono:wght@400;500&family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&family=Sora:wght@600;700;800&display=swap";

function ensurePreconnect() {
  if (
    document.querySelector(
      'link[rel="preconnect"][href="https://fonts.googleapis.com"]',
    )
  ) {
    return;
  }

  const google = document.createElement("link");
  google.rel = "preconnect";
  google.href = "https://fonts.googleapis.com";
  document.head.appendChild(google);

  const gstatic = document.createElement("link");
  gstatic.rel = "preconnect";
  gstatic.href = "https://fonts.gstatic.com";
  gstatic.crossOrigin = "";
  document.head.appendChild(gstatic);
}

function ensureStylesheet(id: string, href: string) {
  if (document.getElementById(id)) return;

  ensurePreconnect();

  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
}

function removeStylesheet(id: string) {
  document.getElementById(id)?.remove();
}

function syncRouteFonts(path: string) {
  if (isMarketingPath(path)) {
    removeStylesheet(PORTAL_FONTS_ID);
    return;
  }

  ensureStylesheet(PORTAL_FONTS_ID, PORTAL_FONT_HREF);
}

/** Load Google Fonts on portal/auth routes only. Marketing stays on self-hosted fonts. */
export default defineNuxtPlugin(() => {
  if (!import.meta.client) return;

  const router = useRouter();

  syncRouteFonts(window.location.pathname);

  router.afterEach((to) => {
    syncRouteFonts(to.path);
  });
});
